var moment = require('moment')

export default class {
  // Retourne une date formatée pour le user
  static getFormatedDate (jsonDate) {
    if (jsonDate !== null && jsonDate !== '') {
      return moment(jsonDate, 'YYYYMMDD').format('L')
    }
    return null
  }

  // Retourne une heure formatée pour le user
  static getFormatedTime (jsonTime) {
    if (jsonTime !== null && jsonTime !== '') {
      return moment(jsonTime, 'HHmmss').format('LT')
    }
    return null
  }

  // Retourne une date formatée pour le user
  static getDateFromInput (inputDate) {
    if (inputDate !== null && inputDate !== '') {
      return moment(inputDate, 'YYYY-MM-DD').format('YYYYMMDD')
    }
    return null
  }

  // Retourne une heure formatée pour le user
  static getTimeFromInput (inputTime) {
    if (inputTime !== null && inputTime !== '') {
      return moment(inputTime, 'HH:mm').format('HHmmss')
    }
    return null
  }

  // Retourne une date formatée pour le champ de saisie
  static getDateForInput (jsonDate) {
    if (jsonDate !== null && jsonDate !== '') {
      return moment(jsonDate, 'YYYYMMDD').format('YYYY-MM-DD')
    }
    return null
  }

  // Retourne une heure formatée pour le champ de saisie
  static getTimeForInput (jsonTime) {
    if (jsonTime !== null && jsonTime !== '') {
      return moment(jsonTime, 'HHmmss').format('HH:mm')
    }
    return null
  }

  // Copie un objet à l'aide du parsing JSON
  static jsonCopy (source) {
    return JSON.parse(JSON.stringify(source))
  }
}
